import { useBooleanState } from '@cian/react-utils';

import React, { memo } from 'react';

import { AdBannerMicrofrontendContainer, type TAdBannerPlaceParameters } from '../AdBannerMicrofrontendContainer';

const PARAMETERS: TAdBannerPlaceParameters = {
  sizes: { width: '100%', height: 542 },
  pParams: { p1: 'crutn', p2: 'fjjq' },
  position: null,
  galleryPosition: null,
  isSp: false,
  tgbNativedescGeneralDesign: null,
  carousel: null,
  deviceType: 'desktop',
  place: 'filters_background',
};

export const FiltersBackgroundAdBannerContainer = memo(() => {
  const { state: isHidden, setTrue: setIsHidden } = useBooleanState(false);

  if (isHidden) {
    return null;
  }

  return <AdBannerMicrofrontendContainer parameters={PARAMETERS} onAdStub={setIsHidden} onAdError={setIsHidden} />;
});

FiltersBackgroundAdBannerContainer.displayName = 'FiltersBackgroundAdBannerContainer';
